import { render, staticRenderFns } from "./InventoryWidgetInventory.vue?vue&type=template&id=6b0054e8&"
import script from "./InventoryWidgetInventory.vue?vue&type=script&lang=ts&"
export * from "./InventoryWidgetInventory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports